"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlTabLayoutContent", function ($rootScope, $compile, $q, templateUtils, $controller, deferredUtils) {
  var INVALIDATION_EVENT = "$PAGE_DATA_UPDATED";
  var defaultTabConfig = {
    tabClass: "",
    unload: false,
    invalidable: false
  };
  return {
    restrict: "E",
    replace: true,
    require: ["tlTabLayoutContent", "^tlTabLayout", "hideableContainer"],
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tabController = controllers[0],
        tabsetController = controllers[1],
        visibilityCtrl = controllers[2];
      tabController.$initialize(tabsetController, visibilityCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        tabsetCtrl = null,
        visibilityCtrl = null,
        tab = $scope.tab,
        tabId = null,
        tabLoaded = false,
        tabContent = null,
        tabScope = null,
        config = null;
      var generateConfig = function generateConfig() {
        var keys = _.keys(defaultTabConfig),
          tabsetConfig = tabsetCtrl.getConfig();
        config = {};
        _.each(keys, function (key) {
          if (_.has(tab, key)) {
            config[key] = tab[key];
          } else if (_.has(tabsetConfig, key)) {
            config[key] = tabsetConfig[key];
          } else {
            config[key] = defaultTabConfig[key];
          }
        });
      };
      ctrl.$initialize = function (_tabsetCtrl, _visibilityCtrl) {
        tabsetCtrl = _tabsetCtrl;
        visibilityCtrl = _visibilityCtrl;
        tabId = tabsetCtrl.getTabId(tab);
        generateConfig();
        $element.attr("tabset-fragment", tab.fragment);
        if (config.tabClass) {
          $element.addClass(config.tabClass);
        }
        $scope.$watch(ctrl.isSelected, function (isSelected) {
          visibilityCtrl.setVisible(isSelected);
        });
        var visibilityChangeHandler = function visibilityChangeHandler(visible) {
          visible ? ctrl.showTab() : ctrl.hideTab();
        };
        visibilityCtrl.on("visibility:change", visibilityChangeHandler);
        var selected = ctrl.isSelected();
        visibilityCtrl.setVisible(selected);
        if (selected) {
          ctrl.showTab();
        }
        if (config.invalidable) {
          bindInvalidationEvents();
        }
      };
      var bindInvalidationEvents = function bindInvalidationEvents() {
        var invalidationHandler = function invalidationHandler() {
          if (visibilityCtrl.isVisible()) {
            return;
          }
          ctrl.unloadTabContent();
        };
        var removeInvalidationListener = $rootScope.$on(INVALIDATION_EVENT, invalidationHandler);
        $scope.$on("$destroy", function () {
          removeInvalidationListener();
        });
      };
      ctrl.isSelected = function () {
        return tabsetCtrl.getSelectedTabId() === tabId;
      };
      ctrl.getFragment = function () {
        return tab.fragment;
      };
      ctrl.usePanelLayout = function (panelLayout) {
        panelLayout ? $element.addClass("has-panel") : $element.removeClass("has-panel");
        ctrl.setPanelOpened(false);
      };

      // only used with panel layout (for pill styles purposes)
      ctrl.setPanelOpened = function (panelOpened) {
        tab.panelOpened = panelOpened;
      };
      ctrl.showTab = function () {
        if (!tabLoaded) {
          ctrl.loadTabContent();
        }
        $element.show();
      };
      ctrl.hideTab = function () {
        if (tabLoaded && config.unload) {
          ctrl.unloadTabContent();
        }
        $element.hide();
      };
      ctrl.unloadTabContent = function () {
        if (tabScope != null) {
          tabScope.$destroy();
          tabScope = null;
          tabContent.remove();
          tabContent = null;
        }
        tabLoaded = false;
      };
      ctrl.loadTabContent = function () {
        var resolvesPromise = deferredUtils.resolvePromiseMap(tab.resolve || {});
        var templatePromise = templateUtils.loadTemplate(tab);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          tabScope = $scope.$new();
          var locals = resolves[0],
            template = resolves[1];
          if (tab.controller) {
            locals.$scope = tabScope;
            locals.$element = $element;
            $controller(tab.controller, locals);
          }
          $compile(template)(tabScope, function (content) {
            tabContent = content;
            $element.append(content);
          });
          tabLoaded = true;
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tabset/tlTabLayoutContent.js
// module id = 3009
// module chunks = 13